export enum UserAddressTypeEnum {
  None,
  Primary,
  Previous,
  Billing,
  Monitoring
}
